<template>
  <!-- <v-card class="pa-4"> -->
    <!-- <div class="flex items-center gap-3 mb-3">
      <v-text-field
        v-model="search"
        density="compact"
        variant="outlined"
        label="Search comments"
        hide-details
        clearable
        class="max-w-[280px]"
      />
      <v-select
        v-model="itemsPerPage"
        :items="perPageOptions"
        density="compact"
        variant="outlined"
        label="Per page"
        hide-details
        class="max-w-[140px]"
      />
      <v-spacer />
      <div class="text-caption text-medium-emphasis">
        {{ filtered.length }} total
      </div>
    </div> -->

    <!-- 3-column grid list -->
    <v-list class="comment-grid" lines="two" density="comfortable">
      <template v-for="c in paged" :key="c.id">
        <v-list-item>
          <template #prepend>
            <v-avatar size="48" :image="`${cloudfrontUrl}${c.shop ? c?.shop.avatar : c?.user.avatar }/AVATAR`"></v-avatar>
          </template>

          <template #title>
            <div class="font-medium">{{ c.user.username }}</div>
          </template>

          <template #subtitle>
            <span class="text-caption text-medium-emphasis">{{ formatDate(c.createdAt) }}</span>
          </template>

          <div class="mt-2 text-body-2 whitespace-pre-line">{{ c.text }}</div>

          <template #append>
            <slot name="item-actions" :item="c" />
          </template>
        </v-list-item>
      </template>

      <v-list-item v-if="!paged.length" class="empty-item">
        <template #title>No comments</template>
        <template #subtitle>Try clearing the search.</template>
      </v-list-item>
    </v-list>

    <div class="d-flex justify-center mt-4">
      <v-pagination v-model="page" :length="pageCount" :total-visible="7" />
    </div>
  <!-- </v-card> -->
</template>

<script setup>
import { computed, ref, watch, defineProps } from 'vue'

const props = defineProps({
  comments: { type: Array, default: () => [] },
  columns: { type: Number, default: 3 },
  perPage: { type: Number, default: 12 },
  perPageOptions: { type: Array, default: () => [9, 12, 15, 18, 24] }
})

const page = ref(1)
const search = ref('')
const itemsPerPage = ref(props.perPage)

const normalized = computed(() => (props.comments ?? []).map(c => ({
  ...c,
  author: c.author ?? 'Anonymous',
  text: c.text ?? '',
})))

const filtered = computed(() => {
  const q = search.value.trim().toLowerCase()
  if (!q) return normalized.value
  return normalized.value.filter(c =>
    c.text.toLowerCase().includes(q) || c.author.toLowerCase().includes(q)
  )
})

const pageCount = computed(() => Math.max(1, Math.ceil(filtered.value.length / itemsPerPage.value)))

watch([itemsPerPage, filtered], () => {
  if (page.value > pageCount.value) page.value = 1
})

const paged = computed(() => {
  const start = (page.value - 1) * itemsPerPage.value
  return filtered.value.slice(start, start + itemsPerPage.value)
})

function formatDate(value) {
  if (!value) return ''
  const d = typeof value === 'string' ? new Date(value) : value
  if (Number.isNaN(d.getTime())) return ''
  return d.toLocaleString()
}
</script>

<style scoped>
.comment-grid {
  display: grid;
  grid-template-columns: repeat(var(--cols, 3), minmax(0, 1fr));
  gap: 12px;
}
.comment-grid .v-list-item {
  border: 1px solid rgba(var(--v-border-color), var(--v-border-opacity));
  border-radius: 12px;
  padding: 12px;
}
.empty-item {
  grid-column: 1 / -1;
  justify-content: center;
  text-align: center;
}
@media (max-width: 1200px) {
  .comment-grid { grid-template-columns: repeat(2, minmax(0, 1fr)); }
}
@media (max-width: 700px) {
  .comment-grid { grid-template-columns: 1fr; }
}
</style>